import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const GutterCardStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: COLORS.WHITE,
    border: `1px solid ${COLORS.GRAY}`,
    borderRadius: 10,
    padding: "10px 20px 10px",
    fontSize: "1rem",
    color: COLORS.DARK_GRAY_2,
    fontFamily: "Inter, sans-serif",
    "& h2": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      color: COLORS.DARK_GRAY_2
    },
    marginBottom: "5rem"
  },
  childrenList: {
    lineHeight: "1rem",
    fontWeight: "normal",
    paddingLeft: "1rem",
    fontSize: "1rem",
    marginTop: ".15rem",
    "& li": {
      marginTop: ".3rem"
    }
  },
  link: {
    color: COLORS.DARK_GRAY_2,
    fontWeight: "normal",
    fontSize: ".9rem",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  parentLink: {
    fontWeight: 600,
    fontSize: "1rem",
    textDecoration: "none"
  }
}));

export default GutterCardStyles;
